const defineFilters = (facets) => (
  Object.keys(facets).reduce((result, key) => (
    { ...result, [key]: [] }
  ), {})
);

export default defineFilters;
